/**
 * BoutonPaiement — PEFEP Site
 * ---------------------------------------------------------------
 * Affiche les plans de mise en ligne et redirige vers le paiement
 * MonCash, hebergé sur PEFEP ACADEMIE (WooCommerce).
 *
 * Le paiement passe par l'academie parce que MonCash y est deja
 * fonctionnel. Une reference (l'identifiant du site) est jointe au
 * lien pour relier chaque paiement au bon site cote admin.
 *
 * Reutilisable a deux endroits : fin du wizard et tableau de bord.
 * - mode "plans" : les 3 plans cote a cote.
 * - mode "renouvellement" : un seul plan.
 *
 * Ecrit a plat : pas de balise <a>, redirection par window.location.
 */

import React, { useState } from 'react';
import './BoutonPaiement.css';

const ACADEMIE = 'https://pefepacademie.com';

// Les identifiants viennent des produits WooCommerce de l'academie.
const PLANS = {
  basique: {
    id: 3943,
    nom: 'Basique',
    prixHtg: '6 600 HTG',
    prixUsd: '49 $',
    details: [
      'Site complet en ligne',
      'Adresse en .pefep.site',
      'Hebergement 1 an inclus',
      'Modifications illimitees',
      'Support WhatsApp',
    ],
  },
  complet: {
    id: 3948,
    nom: 'Complet',
    prixHtg: '10 600 HTG',
    prixUsd: '79 $',
    vedette: true,
    details: [
      'Tout le plan Basique',
      'Adresse en .pefep.site',
      'SEO de base optimise',
      'Integration reseaux sociaux',
      'Support prioritaire 7j/7',
      '1 revision offerte',
    ],
  },
  premium: {
    id: 3949,
    nom: 'Premium',
    prixHtg: '13 500 HTG',
    prixUsd: '100 $',
    details: [
      'Tout le plan Complet',
      'Nom de domaine personnalise (.com)',
      'Boite e-mail professionnelle',
      'Configuration faite par notre equipe',
      'Image de marque renforcee',
    ],
  },
  renouvellement: {
    id: 3950,
    nom: 'Renouvellement annuel',
    prixHtg: '6 750 HTG',
    prixUsd: '50 $',
    details: [
      'Site maintenu en ligne 1 an',
      'Hebergement renouvele',
      'Sauvegardes et securite',
      'Support technique',
    ],
  },
};

function BoutonPaiement({ mode = 'plans', siteId = '', titre }) {
  const [avertissement, setAvertissement] = useState(null);

  function demanderConfirmation(clePlan) {
    setAvertissement(clePlan);
  }

  function allerAuPaiement(clePlan) {
    const plan = PLANS[clePlan];
    const ref = siteId ? '&ref=' + encodeURIComponent(siteId) : '';
    window.location.href = ACADEMIE + '/?add-to-cart=' + plan.id + ref;
  }

  function annuler() {
    setAvertissement(null);
  }

  const clesAffichees =
    mode === 'renouvellement'
      ? ['renouvellement']
      : ['basique', 'complet', 'premium'];

  return (
    <div className="bp-bloc">
      {titre && <h2 className="bp-titre">{titre}</h2>}

      <div className={mode === 'renouvellement' ? 'bp-cartes bp-solo' : 'bp-cartes'}>
        {clesAffichees.map(function (cle) {
          const plan = PLANS[cle];
          return (
            <div className={plan.vedette ? 'bp-carte vedette' : 'bp-carte'} key={cle}>
              {plan.vedette && <div className="bp-ruban">Le plus choisi</div>}
              <div className="bp-nom">{plan.nom}</div>
              <div className="bp-prix">{plan.prixHtg}</div>
              <div className="bp-prix-usd">soit {plan.prixUsd}</div>
              <ul className="bp-details">
                {plan.details.map(function (d, i) {
                  return <li key={i}>{d}</li>;
                })}
              </ul>
              <button
                type="button"
                className={plan.vedette ? 'bp-action vedette' : 'bp-action'}
                onClick={function () {
                  demanderConfirmation(cle);
                }}
              >
                {mode === 'renouvellement' ? 'Renouveler' : 'Choisir ' + plan.nom}
              </button>
            </div>
          );
        })}
      </div>

      {avertissement && (
        <div className="bp-voile" onClick={annuler}>
          <div className="bp-fenetre" onClick={function (e) { e.stopPropagation(); }}>
            <div className="bp-fenetre-titre">Avant de continuer</div>
            <p className="bp-fenetre-texte">
              Vous allez etre redirige vers <strong>PEFEP ACADEMIE</strong>, notre
              plateforme de paiement securisee, pour regler avec MonCash.
            </p>
            <p className="bp-fenetre-texte">
              Une fois votre paiement recu, votre site est mis en ligne en 24 h max.
            </p>
            <div className="bp-fenetre-recap">
              {PLANS[avertissement].nom} — <strong>{PLANS[avertissement].prixHtg}</strong>
            </div>
            <div className="bp-fenetre-actions">
              <button type="button" className="bp-annuler" onClick={annuler}>
                Annuler
              </button>
              <button
                type="button"
                className="bp-confirmer"
                onClick={function () {
                  allerAuPaiement(avertissement);
                }}
              >
                Continuer vers le paiement
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BoutonPaiement;